import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import IconButton from '@material-ui/core/IconButton';
import { Icon } from '@mdi/react';
import { mdiArrowDown } from '@mdi/js/commonjs/mdi';
import { PackageType } from 'client-sdk/src/package-config/interface';

const useStyles = makeStyles(theme => ({
  formControl: {
    minWidth: 164,
    backgroundColor: '#f2f2f2', // Customize background color
    borderRadius: 5, // Customize border radius
    '& .MuiInputLabel-outlined': {
      // Customize label style
      // transform: 'translate(14px, 10px)',
      fontSize: '16px',
      fontWeight: 'normal',
      color: '#666',
    },
    '& .MuiOutlinedInput-root': {
      // Customize input style
      '& fieldset': {
        borderColor: '#ccc', // Customize border color
      },
      '&:hover fieldset': {
        borderColor: '#666', // Customize hover border color
      },
      '&.Mui-focused fieldset': {
        borderColor: '#6e12b6', // Customize focused border color
      },
    },
  },
  iconButton: {
    padding: theme.spacing(1),
    color: '#666', // Customize icon color
    '&:hover': {
      backgroundColor: 'transparent', // Disable hover background color
    },
    '& .MuiSvgIcon-root': {
      // Customize icon style
      fontSize: '1.5rem',
    },
  },
}));

//Type Inference
interface Props {
  label: string;
  value: string;
  onChange: any;
  options: PackageType[];
}

const ITEM_HEIGHT = 48;

const CustomizedSelect: React.FC<Props> = ({
  label,
  value,
  onChange,
  options,
}) => {
  const classes = useStyles();
  const [isOpen, setIsOpen] = useState(false);

  const handleOpen = () => {
    setIsOpen(true);
  };

  const handleClose = event => {
    setIsOpen(false);
  };
  if (options) {
    return (
      <FormControl variant="outlined" className={classes.formControl}>
        <InputLabel>{label}</InputLabel>
        <Select
          label={label}
          variant="outlined"
          value={value}
          onChange={onChange}
          onOpen={handleOpen}
          onClose={handleClose}
          disabled={options?.length < 1}
        >
          {options?.map((option: PackageType) => {
            // console.log('Inside foreach - comp:', option);
            return (
              <MenuItem key={option.id} value={option}>
                {option.name}
              </MenuItem>
            );
          })}
          {/*options.map((option: string) => (
          <MenuItem key={option} value={option}>
            {option}
          </MenuItem>
        ))*/}
        </Select>
      </FormControl>
    );
  } else {
    return null;
  }
};
export default CustomizedSelect;
